<template>
  <div
    class="cart-item"
    :class="{ 'cart-item--loading': loading }"
    data-cy-cart-menu-item
  >
    <div class="row row-no-wrap">
      <div class="cart-item__image">
        <img :src="item.merchandise.image.url" alt="" />
      </div>
      <div class="cart-item__info">
        <p class="w-600 mb-0">
          <nuxt-link
            v-if="isLink"
            :to="resolve({ _type: 'product', uid })"
            class="cart-item__link"
            @click.native="$nuxt.$emit(EVENTS.CLOSE_CART)"
          >
            {{ item.merchandise.product.title }}
            <span v-if="hasGroup">- {{ group }}</span>
          </nuxt-link>
          <span v-else>
            {{ item.merchandise.product.title }}
          </span>
        </p>
        <p class="text-small mb-0-6">{{ item.merchandise.title }}</p>

        <div class="d-flex justify-space-between align-center">
          <form-input-number
            :id="`${item.merchandise.id}-quantity`"
            :label="$t('label.quantity')"
            :value="item.quantity"
            data-cy-cart-item-input-number
            @input="updateQuantity"
          />

          <div class="cart-item__price h6 text-secondary w-700 d-md-none">
            {{ $n(item.cost.totalAmount.amount, 'currency') }}
          </div>
        </div>
      </div>
      <div class="cart-item__price h6 text-secondary w-700 d-none d-md-block">
        {{ $n(item.cost.totalAmount.amount, 'currency') }}
      </div>
    </div>
  </div>
</template>

<script>
import FormInputNumber from '@/components/form/InputNumber'
import { EVENTS } from '@/const/events'
import ShopifyBase64 from '@/utils/shopifyBase64'

export default {
  name: 'CartItem',
  components: {
    FormInputNumber,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ EVENTS }),
  computed: {
    isLink() {
      return (
        ShopifyBase64.getId(this.item.merchandise.product.id) !==
          process.env.SUIT_HOUSE_ID || this.$i18n.locale !== toLocale
      )
    },
    hasGroup() {
      return (
        this.item.merchandise.selectedOptions.length > 0 &&
        this.item.merchandise.selectedOptions.some((s) => s.name === 'Group')
      )
    },
    group() {
      const g = this.item.selectedOptions.find((s) => s.name === 'Group')

      if (g) {
        return g.value
      }

      return ''
    },
    uid() {
      const slug = this.item.attributes.find((a) => a.key === '_slug')
      if (slug) {
        return slug.value
      }

      return item.productHandle
    },
    toLocale() {
      const locale = this.item.attributes.find((a) => a.key === '_locale')
      if (locale) {
        return locale.value
      }

      return this.$i18n.locale
    },
  },
  methods: {
    resolve(l) {
      return this.$contextSanityPath(l)
    },
    updateQuantity(q) {
      this.$emit('update-quantity', this.item, parseInt(q))
    },
  },
}
</script>

<style lang="scss">
.cart-item {
  padding-top: rem($spacing);

  @include mq($from: tablet) {
    padding-top: rem($spacing * 1.5);
  }

  &__image {
    padding-right: rem($spacing);

    img {
      width: rem(86px);
    }
  }

  &__info {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &__link {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;

    @include on-hover-and-focus {
      text-decoration: underline;
    }

    .moving & {
      pointer-events: none;
    }
  }

  &__price {
    align-self: flex-end;

    @include mq($from: tablet) {
      align-self: center;
    }
  }

  .input--number {
    margin-bottom: 0;

    label {
      @include visually-hidden;
    }
  }

  &--loading {
    .input--number {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
